export default function BySeverityConfig() {
  return {
    itemName: 'Severity',
    itemNamePlural: 'Severities',
    commonStateItemSelector: commonState => commonState.severityList,
    getUrlParamName: 'severity_ids'
  };
};